// Translated from the English source with an external model, then reviewed. Regenerate with
// scripts/import-translation-bundle.ts rather than editing by hand — a hand edit here is lost
// the next time a bundle comes back.

export const STATIC_PAGE_COPY_DE = {
  "/": {
    "title": "Heartopia.guide — Inselkarte, Rezepte, Tracker & mehr",
    "description":
      "Heartopia-Feldguide von Spielern: interaktive Inselkarte, Fische, Insekten, Vögel, Feldfrüchte, Kochrezepte, NPCs, Geschenkcodes und vollständiger Sammel-Tracker.",
  },
  "/map": {
    "title": "Interaktive Heartopia-Inselkarte — Alle Orte | Heartopia.guide",
    "description":
      "Erkunde die vollständige Heartopia-Inselkarte mit allen Orten, Angelgebieten, NPCs und Läden sowie Filtern für Fischplätze, Sammelgebiete und Sammelobjekte.",
  },
  "/tracker": {
    "title": "Heartopia-Sammeltracker — Fische, Insekten, Vögel & mehr | Heartopia.guide",
    "description":
      "Verfolge deine Heartopia-Sammlung: Markiere Fische, Insekten, Vögel, Feldfrüchte, Blumen, Sammelobjekte, Rezepte und Tiere als gesammelt. Der Fortschritt wird im Browser gespeichert.",
  },
  "/items": {
    "title": "Alle Heartopia-Gegenstände — Vollständiger Katalog | Heartopia.guide",
    "description":
      "Durchsuche den vollständigen Heartopia-Katalog: Fische, Insekten, Vögel, Feldfrüchte, Blumen, Gerichte, Werkzeuge, Möbel und mehr, inklusive Verkaufspreisen und Fundorten.",
  },
  "/locations": {
    "title": "Alle Heartopia-Orte | Heartopia.guide",
    "description":
      "Jeder Ort in Heartopia: Was du in den einzelnen Gebieten fischen, fangen und sammeln kannst, plus die NPCs und Läden vor Ort.",
  },
  "/npcs": {
    "title": "Alle Heartopia-NPCs — Rollen, Läden & Zeitpläne | Heartopia.guide",
    "description":
      "Lerne alle Heartopia-NPCs kennen: ihre Rolle auf der Insel, welchen Laden sie betreiben und wo du sie im Tagesverlauf findest.",
  },
  "/shops": {
    "title": "Alle Heartopia-Läden & ihre Waren | Heartopia.guide",
    "description":
      "Alle Läden in Heartopia mit ihrem vollständigen Sortiment: Waren, Preise und welcher NPC den jeweiligen Laden betreibt.",
  },
  "/wardrobe": {
    "title": "Alle Outfits & Accessoires in Heartopia | Heartopia.guide",
    "description":
      "Alle 2.239 Kleidungsgegenstände in Heartopia — Hüte, Oberteile, Unterteile, Schuhe, Taschen und Haare — filterbar nach Slot, Sammlung und Farbe, mit Preisen und allen Designvarianten.",
  },
  "/buildings": {
    "title": "Alle Bauteile in Heartopia — Baumodus | Heartopia.guide",
    "description":
      "Alle 452 Bauteile im Baumodus von Heartopia — Türen, Fenster, Dächer, Zäune, Wandskulpturen sowie Wand- und Bodentexturen — nach Baustil gruppiert, mit Preisen.",
  },
  "/guides": {
    "title": "Heartopia-Guides — Fishing, Cooking, Haustiere & Leveln | Heartopia.guide",
    "description":
      "Heartopia-Guides für Anfänger und Fortgeschrittene: Fishing, Gardening, Cooking, Birdwatching, Bug Catching, Haustierpflege und schnelles Leveln.",
  },
  "/achievements": {
    "title": "Heartopia-Erfolge — Vollständige Liste | Heartopia.guide",
    "description":
      "Alle Heartopia-Erfolge und wie du sie abschließt — Voraussetzungen, Belohnungen und Tipps zum Vervollständigen deiner Erfolgsliste.",
  },
  "/weather": {
    "title": "Heartopia-Wetter-Guide — Was jede Wetterlage freischaltet | Heartopia.guide",
    "description":
      "So funktioniert das Wetter in Heartopia: Welche Fische, Insekten und Events von Regen, Schnee und anderen Bedingungen abhängen und wie du deine Route nach der Vorhersage planst.",
  },
  "/events": {
    "title": "Heartopia-Events — Aktuelle & vergangene Events | Heartopia.guide",
    "description":
      "Jedes Heartopia-Event: aktuelle und vergangene saisonale Events, exklusive Gegenstände und wie du Event-Belohnungen erhältst, bevor sie wechseln.",
  },
  "/pets": {
    "title": "Heartopia-Haustiere — Hunde, Katzen, Eigenschaften & Pflege | Heartopia.guide",
    "description":
      "Alles über Heartopia-Haustiere: alle Hunde- und Katzenrassen, Eigenschaften und wie du deine Begleiter adoptierst, fütterst und versorgst.",
  },
  "/pets/dogs": {
    "title": "Alle Hunderassen in Heartopia | Heartopia.guide",
    "description":
      "Jede Hunderasse, die du in Heartopia adoptieren kannst, mit Aussehen, Eigenschaften und Adoptionsdetails.",
  },
  "/pets/cats": {
    "title": "Alle Katzenrassen in Heartopia | Heartopia.guide",
    "description":
      "Jede Katzenrasse, die du in Heartopia adoptieren kannst, mit Aussehen, Eigenschaften und Adoptionsdetails.",
  },
  "/pets/traits": {
    "title": "Heartopia-Haustiereigenschaften erklärt | Heartopia.guide",
    "description":
      "Alle Persönlichkeitseigenschaften von Haustieren in Heartopia und ihre Wirkung — wie sie das Verhalten beeinflussen und welche Kombinationen interessant sind.",
  },
  "/pets/guide": {
    "title": "Heartopia-Haustierpflege-Guide | Heartopia.guide",
    "description":
      "So kümmerst du dich um Haustiere in Heartopia: Adoption, Füttern, Zufriedenheit, Spaziergänge und alles, was dein Hund oder deine Katze täglich braucht.",
  },
  "/daily-checklist": {
    "title": "Heartopia-Tagescheckliste — Keine Aufgabe verpassen | Heartopia.guide",
    "description":
      "Eine Tages-Checkliste für Heartopia: wiederkehrende Aufgaben, Resets und Routinen, um jeden Ingame-Tag optimal zu nutzen.",
  },
  "/codes": {
    "title": "Heartopia-Geschenkcodes — Aktive Codes & Belohnungen | Heartopia.guide",
    "description":
      "Alle aktiven Heartopia-Geschenkcodes und ihre Belohnungen sowie eine Anleitung zum Einlösen — regelmäßig geprüft und aktualisiert.",
  },
  "/tracking-winter-season": {
    "title": "Heartopia-Wintersaison-Tracker | Heartopia.guide",
    "description":
      "Verfolge die Heartopia-Wintersaison: saisonale Fische, Insekten, Event-Gegenstände und alles, was du nur während des Winters sammeln kannst.",
  },
  "/support": {
    "title": "Heartopia.guide unterstützen | Heartopia.guide",
    "description":
      "So unterstützt du Heartopia.guide — den kostenlosen, von Spielern erstellten Feldguide — und hilfst, ihn für alle aktuell zu halten.",
  },
  "/news": {
    "title": "Heartopia-News — Updates, Events & Patch-Abdeckung | Heartopia.guide",
    "description":
      "Die neuesten Heartopia-News: Spiel-Updates, saisonale Events, neue Inhalte und Patch-Abdeckung an einem Ort.",
  },
  "/sitemap": {
    "title": "Sitemap — Alle Seiten auf Heartopia.guide | Heartopia.guide",
    "description":
      "Durchsuche jeden Bereich von Heartopia.guide an einem Ort: Fische, Insekten, Vögel, Blumen, Rezepte, NPCs, Orte, Guides und News.",
  },
} as const;
